import { render, staticRenderFns } from "./FinancesExpensesCategoryForm.vue?vue&type=template&id=6cb44034&scoped=true&"
import script from "./FinancesExpensesCategoryForm.vue?vue&type=script&lang=js&"
export * from "./FinancesExpensesCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./FinancesExpensesCategoryForm.vue?vue&type=style&index=0&id=6cb44034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb44034",
  null
  
)

export default component.exports